/**
 * Do not edit directly
 * Generated on Mon, 17 May 2021 20:46:10 GMT
 */

import { css } from 'styled-components';

export type Spacing = '0x' | '1x' | '2x' | '3x' | '4x' | '5x' | '6x' | '8x' | '12x' | '16x' | '24x';
export type FontWeight = 'regular' | 'semibold' | 'extrabold';
export type TextAlign = 'left' | 'center' | 'right';
export type TextColor =
  | 'primary'
  | 'primary_inverse'
  | 'secondary'
  | 'secondary_inverse'
  | 'tertiary'
  | 'tertiary_inverse'
  | 'disabled'
  | 'placeholder'
  | 'error'
  | 'price'
  | 'caution'
  | 'success'
  | 'info';
export type TextDecoration = 'none' | 'underline';
export type TextTransform = 'none' | 'uppercase';
export type HeadingSizes = '100' | '200' | '300' | '400' | '500' | '600';
export type ResponsiveHeadingSizes = '400' | '500' | '600';
export type ParagraphSizes = '100' | '200' | '300';
export type TextSizes = '100' | '200' | '300';

export const WEB_FALLBACK_FONT_FAMILIES = 'Avenir, Helvetica Neue, Helvetica, sans-serif';

export type HeadingStyles = { [key in HeadingSizes]: any };
export const headingStyles: HeadingStyles = {
  '100': css`
    font-family: Averta-Semibold, Avenir, Helvetica Neue, Helvetica, sans-serif;
    font-size: 13px;
    font-weight: 600 !important;
    line-height: 1.25;
    margin-bottom: 8px;
  `,
  '200': css`
    font-family: Averta-Semibold, Avenir, Helvetica Neue, Helvetica, sans-serif;
    font-size: 16px;
    font-weight: 600 !important;
    line-height: 1.25;
    margin-bottom: 12px;
  `,
  '300': css`
    font-family: Averta-Semibold, Avenir, Helvetica Neue, Helvetica, sans-serif;
    font-size: 20px;
    font-weight: 600 !important;
    line-height: 1.25;
    margin-bottom: 16px;
  `,
  '400': css`
    font-family: Averta-Extrabold, Avenir, Helvetica Neue, Helvetica, sans-serif;
    font-size: 26px;
    font-weight: 800 !important;
    line-height: 1.25;
    margin-bottom: 20px;
  `,
  '500': css`
    font-family: Averta-Extrabold, Avenir, Helvetica Neue, Helvetica, sans-serif;
    font-size: 32px;
    font-weight: 800 !important;
    line-height: 1.25;
    margin-bottom: 24px;
  `,
  '600': css`
    font-family: Averta-Extrabold, Avenir, Helvetica Neue, Helvetica, sans-serif;
    font-size: 38px;
    font-weight: 800 !important;
    line-height: 1.25;
    margin-bottom: 32px;
  `,
};
export type ResponsiveHeadingStyles = { [key in ResponsiveHeadingSizes]: any };
export const responsiveHeadingStyles: ResponsiveHeadingStyles = {
  '400': css`
    font-size: 32px;
  `,
  '500': css`
    font-size: 40px;
  `,
  '600': css`
    font-size: 48px;
  `,
};
export type ParagraphStyles = { [key in ParagraphSizes]: any };
export const paragraphStyles: ParagraphStyles = {
  '100': css`
    font-size: 13px;
    font-weight: 400 !important;
    line-height: 1.5;
    margin-bottom: 12px;
  `,
  '200': css`
    font-size: 16px;
    font-weight: 400 !important;
    line-height: 1.5;
    margin-bottom: 16px;
  `,
  '300': css`
    font-size: 20px;
    font-weight: 400 !important;
    line-height: 1.5;
    margin-bottom: 24px;
  `,
};

export type TextStyles = { [key in TextSizes]: any };
export const textStyles: TextStyles = {
  '100': css`
    font-size: 13px;
    font-weight: 400 !important;
    line-height: 1.25;
  `,
  '200': css`
    font-size: 16px;
    font-weight: 400 !important;
    line-height: 1.5;
  `,
  '300': css`
    font-size: 20px;
    font-weight: 400 !important;
    line-height: 1.2;
  `,
};

export type Theme = {
  space: { [key in Spacing]: string };
  fontWeight: { [key in FontWeight]: string | number };
  textAlign: { [key in TextAlign]: string };
  textColor: { [key in TextColor]: string };
  textDecoration: { [key in TextDecoration]: string };
  textTransform: { [key in TextTransform]: string };
  buttons: Record<string, Record<string, unknown>>;
  variants: Record<string, Record<string, string>>;
  colors: Record<string, Record<string, string | Record<string, string>>>;
  background: Record<string, string | Record<string, string>>;
  backgroundImage?: { gradient: Record<string, string> };
  shadows: Record<string, string>;
  radii: Record<string, string>;
  breakpoints: string[];
};

const theme: Theme = {
  breakpoints: ['768px', '992px', '1200px'],
  colors: {
    border: {
      primary: '#CFD7DE',
      secondary: '#DCE1E5',
      contrast: '#66727C',
      error: '#E51A42',
      input_focus: '#16A2BB',
    },
    neutral: {
      '12': '#1B1F23',
      '28': '#40484F',
      '44': '#66727C',
      '56': '#84909A',
      '84': '#CFD7DE',
      '88': '#DCE1E5',
      '92': '#E8EBED',
      '96': '#F4F5F6',
      '100': '#FFFFFF',
    },
    green: {
      '24': '#007948',
      '28': '#098855',
      '70': '#71F4BF',
      '96': '#ECFEF7',
      base: '#14A96D',
    },
    blue: {
      '28': '#06748A',
      '32': '#0281A2',
      '70': '#7DD3E8',
      '96': '#ECFBFE',
      base: '#16A2BB',
    },
    purple: {
      '40': '#504BB4',
      '70': '#8A85E0',
      '96': '#ECECFE',
      base: '#6964BD',
    },
    red: {
      '40': '#C20A2F',
      '70': '#FC697B',
      '96': '#FEECEE',
      base: '#E51A42',
    },
    orange: {
      '40': '#CC4E00',
      '70': '#FFA166',
      '96': '#FEF3EC',
      base: '#FF8133',
    },
    yellow: {
      '28': '#8C6C05',
      '70': '#F7D96E',
      '96': '#FEFAEC',
      base: '#FFCF33',
    },
    brand: {
      rover: '#00BD70',
      dogbuddy: '#FF5A5B',
      facebook: '#3B5998',
      instagram: '#8A3AB9',
      twitter: '#1DA1F2',
      pinterest: '#C8232C',
      google: '#4285F4',
    },
    interactive_text: {
      primary_base: '#40484F',
      primary_active: '#007948',
      disabled_base: '#84909A',
      link_primary_base: '#0281A2',
      link_primary_pressed: '#06748A',
      link_primary_inverse_base: '#FFFFFF',
      link_secondary_base: '#66727C',
      link_secondary_pressed: '#40484F',
      link_secondary_inverse_base: '#F4F5F6',
    },
    interactive_border: {
      primary_base: '#CFD7DE',
      primary_pressed: '#84909A',
      primary_active: '#14A96D',
      disabled_base: '#E8EBED',
    },
    separator: {
      primary: '#CFD7DE',
    },
    text: {
      primary: '#1B1F23',
      primary_inverse: '#FFFFFF',
      secondary: '#40484F',
      secondary_inverse: '#F4F5F6',
      tertiary: '#66727C',
      tertiary_inverse: '#E8EBED',
      disabled: '#84909A',
      placeholder: '#66727C',
      error: '#E51A42',
      price: '#CC4E00',
      caution: '#8C6C05',
      success: '#098855',
      info: '#06748A',
    },
  },
  background: {
    contrast: '#40484F',
    overlay: 'rgba(27, 31, 35, 0.48)',
    overlay_accent: 'rgba(20, 169, 109, 0.24)',
    tertiary: '#E8EBED',
    secondary: '#F4F5F6',
    primary: '#FFFFFF',
    error: '#FEECEE',
    accent: '#00BD70',
    interactive: {
      primary_base: '#FFFFFF',
      primary_pressed: '#F4F5F6',
      primary_active: '#ECFEF7',
      primary_active_pressed: 'rgba(113, 244, 191, 0.32)',
      error_pressed: 'rgba(252, 105, 123, 0.24)',
      disabled_base: '#F4F5F6',
    },
    gradient: {
      base: 'linear-gradient(45deg, #00CD7A 0%, #14A96D 50%, #00CD7A 100%)',
      primary: 'linear-gradient(180deg, #178C5F 0%, #207E4F 100%)',
      primary_pressed: 'linear-gradient(180deg, #207E4F 0%, #007948 100%)',
      contrast: 'linear-gradient(180deg, #2DDF96 0%, #1ACD84 100%)',
      contrast_pressed: 'linear-gradient(180deg, #1CBA7A 0%, #149E66 100%)',
      destructive: 'linear-gradient(180deg, #FD3225 0%, #FF645A 100%)',
      destructive_pressed: 'linear-gradient(180deg, #BA1C11 0%, #DB291D 100%)',
    },
  },
  space: {
    '0x': '0px',
    '1x': '4px',
    '2x': '8px',
    '3x': '12px',
    '4x': '16px',
    '5x': '20px',
    '6x': '24px',
    '8x': '32px',
    '12x': '48px',
    '16x': '64px',
    '24x': '96px',
  },
  radii: {
    primary: '8px',
    secondary: '4px',
    round: '99999px',
  },
  shadows: {
    elevation_high: '0px 8px 10px -6px rgba(27, 31, 35, 0.22)',
    elevation_mid: '0px 2px 12px -1px rgba(27, 31, 35, 0.24)',
    elevation_low: '0px 1px 4px 0px rgba(27, 31, 35, 0.32)',
    border_primary: '0px 0px 0px 2px rgba(207, 215, 222, 1)',
    border_contrast: '0px 0px 0px 2px rgba(102, 114, 124, 1)',
    border_disabled: '0px 0px 0px 2px rgba(232, 235, 237, 1)',
  },
  fontWeight: {
    regular: '400 !important',
    semibold: '600 !important',
    extrabold: '800 !important',
  },
  textColor: {
    primary: '#1B1F23',
    primary_inverse: '#FFFFFF',
    secondary: '#40484F',
    secondary_inverse: '#F4F5F6',
    tertiary: '#66727C',
    tertiary_inverse: '#E8EBED',
    disabled: '#84909A',
    placeholder: '#66727C',
    error: '#E51A42',
    price: '#CC4E00',
    caution: '#8C6C05',
    success: '#098855',
    info: '#06748A',
  },
  textAlign: {
    left: 'left',
    center: 'center',
    right: 'right',
  },
  textDecoration: {
    none: 'none',
    underline: 'underline',
  },
  textTransform: {
    none: 'none',
    uppercase: 'uppercase',
  },
  variants: {
    card_default: {
      padding: '5x',
      boxShadow: 'elevation_mid',
      borderRadius: 'primary',
    },
    elevation_low: {
      borderRadius: 'default',
      boxShadow: 'elevation_low',
    },
    elevation_mid: {
      borderRadius: 'default',
      boxShadow: 'elevation_mid',
    },
    elevation_high: {
      borderRadius: 'default',
      boxShadow: 'elevation_high',
    },
  },
  buttons: {
    base: {
      borderRadius: 'round',
      cursor: 'pointer',
      bg: 'transparent',
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'antialiased',
      ':focus,:hover': {
        textDecoration: 'none',
      },
    },
    disabled: {
      variant: 'buttons.base',
      color: 'text.disabled',
      background: 'interactive.disabled_base',
      boxShadow: 'border_disabled',
      cursor: 'not-allowed',
      ':hover,:focus': {
        color: 'text.disabled',
      },
    },
    default: {
      base: {
        variant: 'buttons.base',
        color: 'text.secondary',
        background: 'interactive.primary_base',
        boxShadow: 'border_primary',
        ':hover,:focus': {
          color: 'text.secondary',
          background: 'interactive.primary_pressed',
        },
      },
      contrast: {
        variant: 'buttons.base',
        color: 'text.primary_inverse',
        background: 'contrast',
        boxShadow: 'border_contrast',
        ':hover,:focus': {
          color: 'text.primary_inverse',
          backgroundColor: 'neutral.12',
        },
      },
      destructive: {
        variant: 'buttons.default.base',
        color: 'red.40',
        ':hover,:focus': {
          color: 'red.40',
          background: 'error',
        },
      },
      contrastDestructive: {
        variant: 'buttons.base',
        color: 'red.96',
        boxShadow: 'border_contrast',
        ':hover,:focus': {
          color: 'red.70',
          background: 'interactive.error_pressed',
        },
      },
    },
    primary: {
      base: {
        variant: 'buttons.base',
        color: 'text.primary_inverse',
        background: 'gradient.primary',
        boxShadow: 'elevation_mid',
        ':hover,:focus': {
          color: 'text.primary_inverse',
          background: 'gradient.primary_pressed',
        },
      },
      contrast: {
        variant: 'buttons.base',
        color: 'text.primary',
        background: 'gradient.contrast',
        boxShadow: 'elevation_mid',
        ':hover,:focus': {
          color: 'text.primary',
          background: 'gradient.contrast_pressed',
        },
      },
      destructive: {
        variant: 'buttons.base',
        color: 'text.primary_inverse',
        background: 'gradient.destructive',
        boxShadow: 'elevation_mid',
        ':hover,:focus': {
          color: 'text.primary_inverse',
          background: 'gradient.destructive_pressed',
        },
      },
      contrastDestructive: {
        variant: 'buttons.base',
        color: 'text.error',
        background: 'interactive.primary_base',
        boxShadow: 'elevation_mid',
        ':hover,:focus': {
          color: 'text.error',
          background: 'error',
        },
      },
    },
    flat: {
      base: {
        variant: 'buttons.base',
        color: 'text.secondary',
        ':hover,:focus': {
          color: 'text.primary',
          background: 'interactive.primary_pressed',
        },
      },
      contrast: {
        variant: 'buttons.base',
        color: 'text.secondary_inverse',
        ':hover,:focus': {
          color: 'text.primary_inverse',
          backgroundColor: 'neutral.12',
        },
      },
      destructive: {
        variant: 'buttons.base',
        color: 'text.error',
        ':hover,:focus': {
          color: 'red.40',
          background: 'interactive.error_pressed',
        },
      },
      contrastDestructive: {
        variant: 'buttons.base',
        color: 'red.70',
        ':hover,:focus': {
          color: 'red.96',
          background: 'interactive.error_pressed',
        },
      },
    },
  },
};

export default theme;



// WEBPACK FOOTER //
// ../kibble/tokens/build/es6/theme.ts